

import firebase from 'firebase';
const fb = require('../../../firebaseConfig.js')
export default {
    data() {
        return {
          timetables:[]
        };
    },
    methods: {
        async _getTimeTables(path){
            var newpath="timetable";
            if(path!=null&&path!=''&&path!=undefined){
                newpath = path;
            }
            fb.db.collection(newpath).get().then(snapshot=>{
               
                if(snapshot && !snapshot.empty){
                    for(const tDoc of snapshot.docs){
                        let item=tDoc.data();
                        item.id=tDoc.id;
                        this.timetables.push(item);
                    }
                }
            });
        },
        isIn(id){
            var result=false;
            var resultvalue=null;
            if(id && this.timetables && this.timetables.length>0){
                for(const value of this.timetables){
                    if(value && value.id==id){
                        
                        result=true;
                        resultvalue=value;
                        break;
                    }
                }
            }
            if(resultvalue && resultvalue.time)
                return resultvalue.time;
            return null;
        }

    },
    
}
